export const filtersToQueryParams = (filters: NewsAndEventsFilters) =>
  (filters.department ? [`department=${filters.department}`] : [])
    .concat(
      filters.subDepartment ? [`subdepartment=${filters.subDepartment}`] : []
    )
    .concat(filters.specialist ? [`specialist=${filters.specialist}`] : [])
    .concat(filters.tags ? filters.tags.map((tag) => `tags=${tag}`) : [])
    .concat(filters.centrum ? [`centrum=${filters.centrum}`] : [])
    .concat(filters.subcentra ? [`subcentra=${filters.subcentra}`] : [])
    .join('&')

export type NewsAndEventsFilters = {
  department?: string
  subDepartment?: string
  specialist?: string
  tags?: string[]
  centrum?: string
  subcentra?: string
}

export type VerpleegafdelingenFilters = {
  locationName?: string
}
